export { default } from './useGetSrpRecentlyViewed';
